import { Injectable } from '@angular/core';

import { filter, map, mergeMap } from 'rxjs/operators';

import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

const APP_TITLE = 'Delta |';
const SEPARATOR = ' > ';

@Injectable()
export class TitleService {
  constructor(
    private translateService:TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
  ) {}

  init() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data),
      map((data) => {
        if ( data.breadcrumb ) {
          // If a route has a breadcrumb set (e.g. data: {breadcrumb: "Foo"}) then we use it
          return data.breadcrumb;
        } else {
            // If not, we do a little magic on the url to create an approximation
            return this.router.url.split('/').reduce((acc, frag) => {
                if (acc && frag) {
                    acc += SEPARATOR;
                }
                return acc + TitleService.ucFirst(frag);
            }, '');
        }
      })
    ).subscribe((pathString) => {
        if (!pathString) { return; }
        this.translateService.stream(pathString).subscribe(response=>{
          this.titleService.setTitle(`${APP_TITLE} ${this.translateService.instant(response)}`)
        });
      });
  }

  static ucFirst(string: string) {
    if ( !string ) { return string; }
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
}